export { default } from './DropdownLayout.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/DropdownLayout/index.js